(function($){
  'use strict';
    if(!$.gnv){
      $.gnv = new Object();
    };

    $.gnv.enableCreditCardInfo =  function (){
      $('[data-credit-card-info]').gnv_CreditCardInfo();
    };

    $.gnv.reloadCreditCardInfo =  function (){
      $('[data-credit-card-info]').gnv_CreditCardInfo();
    };

    $.gnv.creditCardInfo = function(el, options){
      var base = this;

      base.$el = $(el);
      base.el = el;

      base.$el.data("gnv.creditCardInfo", base);

      base.init = function(){
        base.options = $.extend({},$.gnv.creditCardInfo.defaultOptions, options);

        base.$creditCardPopup = base.$el.find('[data-credit-card-popup]');

        base.$el.find('[data-credit-card-btn]').on("click touchstart", function (e){
          e.preventDefault();
          e.stopPropagation();
          base.$creditCardPopup.toggle();
        });

        base.$creditCardPopup.on("click touchstart", function (e) {
          e.stopPropagation();
        });

        $(document).on("click touchstart", function () {
          base.$creditCardPopup.hide();
        });

      };
      base.init();
  };

  $.gnv.creditCardInfo.defaultOptions = {
  };

  $.fn.gnv_CreditCardInfo = function(options){
    return this.each(function(){
      (new $.gnv.creditCardInfo(this, options));
    });
  };

})(jQuery);

